import React, { useState, useEffect, useMemo, useContext } from "react";
import { Box, Button } from "@mui/material";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";


export default function ImageHandler({ image }) {
    const { error } = useContext(PrivateRoutesContext);

    const [fileInputRef, setFileInputRef] = useState({});

    const handleUploadImage = (e) => {
        if (!e.target.files || !e.target.files[0]) {
            // no file selected
            console.log("No file selected");
        }
        else if (!(/^image\/(png|jpe?g|gif)$/).test(e.target.files[0].type)) {
            // not image error
            console.log("not image error");
            
            error.setTitle("An Error Occurred");
            error.setText("Please select a png, jpeg or gif.");
            error.setDoShowError(true);
        }
        else {
            var img = document.createElement("img");
            
            img.onload = () => {
                if (img.width > image.maxWidth || img.height > image.maxHeight) {
                    error.setTitle("Selected file is too large");
                    error.setText(`Please select a file that is no more than ${image.maxHeight} x ${image.maxWidth}.`);
                    error.setDoShowError(true);
                }
                else {
                    image.setLogo(e.target.files[0]);
                    image.setIsUpdated(true);
                }
            }

            img.src = URL.createObjectURL(e.target.files[0]);
        }
    }

    const handleRemoveImage = () => {
        setFileInputRef(prev => { prev.value = ""; return prev; })
        image.setLogo(null);
        image.setIsUpdated(true);
    }

    return <Box className="col-lg-3">
        <Box className="col-12" sx={{ fontWeight: 500, fontSize: "24px" }}>{image.title}</Box>
        <Box className="col-12 mb-3">Max Dimensions: {image.maxHeight} H x {image.maxWidth} W</Box>
        <Box className="col-12 mb-2">
            <img src={image.src} style={{ maxWidth: "250px" }} />
        </Box>
        <Box className="d-flex">
            <Box className="px-1">
                <Button
                    variant="outlined"
                    component="label"
                >
                    Select File
                    <input
                        type="file"
                        hidden
                        // value={image.fileName}
                        accept="image/png, image/jpeg"
                        onChange={e => handleUploadImage(e)}
                        ref={ref => setFileInputRef(ref)} />
                </Button>
            </Box>
            <Box className="px-1">
                <Button
                    variant="outlined"
                    component="label"
                    onClick={e => handleRemoveImage()}
                >
                    Remove
                </Button>
            </Box>
        </Box>
    </Box>;
}